module.exports = __webpack_public_path__ + "img/cz-partners-blesk.a4a8a102.svg";